import React, { useState, useEffect } from 'react';

const AnimatedNumber = ({ value, className = '' }) => {
    const [displayValue, setDisplayValue] = useState(value);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (value !== displayValue) {
            setIsAnimating(true);

            // Short delay to trigger CSS animation
            const timer = setTimeout(() => {
                setDisplayValue(value);

                // Reset animation state after animation completes
                setTimeout(() => {
                    setIsAnimating(false);
                }, 300); // Match CSS animation duration
            }, 50);

            return () => clearTimeout(timer);
        }
    }, [value, displayValue]);

    const formatNumber = (num) => {
        if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
        if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
        return num.toString();
    };

    return (
        <span
            className={`animated-number ${isAnimating ? 'animating' : ''} ${className}`}
            key={displayValue} // Force re-render on value change for animation
        >
            {formatNumber(displayValue)}
        </span>
    );
};

export default AnimatedNumber;
